var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-container"},[_c('vue-select',_vm._b({attrs:{"options":_vm.selectOptions,"searchable":false,"show-labels":false,"components":{ Deselect: _vm.Deselect }},on:{"input":_vm.onSelect}},'vue-select',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }